/* eslint-disable class-methods-use-this */

/* eslint-disable prefer-promise-reject-errors */
import axios from "axios";
import {v4 as uuid} from "uuid";

import {
  API_IN_HOUSE,
  API_IN_HOUSE_KEY,
  API_TMS,
  API_TMS_KEY,
  COMMON_HEADER_CONFIG
} from "../config";

class WaybillService {
  getAccessToken = () => localStorage.getItem("accessToken");

  userId = () => localStorage.getItem("userId");

  requestCreateWaybill = (data) =>
    new Promise((resolve, reject) => {
      const dataCreate = JSON.stringify(data);
      const config = {
        method: "post",
        url: `${API_TMS}/request-delivery-order`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          "x-user-id": this.userId(),
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json",
          "api-key": API_TMS_KEY
        },
        data: dataCreate
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getWaybillRequest = (params) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_TMS}/search-request-delivery-order`,
        params: {
          size: 10,
          page: 1,
          ...params
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "api-key": API_TMS_KEY,
          "x-user-id": this.userId()
        }
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getLinkRequestDeliveryOrder = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_TMS}/get-link-request-delivery-order/${id}`,
        responseType: "blob",
        headers: {
          ...COMMON_HEADER_CONFIG,
          Accept: "application/pdf",
          "api-key": API_TMS_KEY,
          "x-user-id": this.userId()
        }
      };

      axios(config)
        .then((response) => {
          if (response.status === 200) {
            resolve(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  // cancel waybill in created status
  deleteWaybillRequest = (shipmentId) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_TMS}/cancel-delivery-order/${shipmentId}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "api-key": API_TMS_KEY,
          "x-user-id": this.userId()
        }
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject({message: response.data.data});
          }
        })
        .catch((error) => {
          reject({message: error.response.data.data});
        });
    });

  // cancel waybill in waiting status
  deleteRequestDeliveryOrder = (orderNumber) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "delete",
        url: `${API_TMS}/cancel-request-delivery-order/${orderNumber}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "api-key": API_TMS_KEY,
          "x-user-id": this.userId()
        }
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject({message: response.data.data});
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getWaybillByIdRequest = (params) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_TMS}/request-delivery-order/${params.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "api-key": API_TMS_KEY,
          "x-user-id": this.userId()
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createWaybillRequest = (params) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_TMS}/create-delivery-order`,
        headers: {
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json",
          "api-key": API_TMS_KEY,
          "x-user-id": this.userId(),
          "w-request-id": uuid()
        },
        data: params
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateWaybillRequest = (params) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "put",
        url: `${API_TMS}/update-request-delivery-order/${params.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "api-key": API_TMS_KEY,
          "x-user-id": this.userId()
        },
        data: params
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getTransporterServices = (params) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "GET",
        url: `${API_TMS}/transporter-services`,
        params: {
          transporter: params
        },
        headers: {
          Authorization: `Bearer ${this.getAccessToken()}`,
          "api-key": API_TMS_KEY,
          "x-user-id": this.userId()
        }
      };
      axios(config)
        .then((response) => {
          if (response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createMultiDeliveryInhouse = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "POST",
        url: `${API_TMS}/create-multi-delivery-order`,
        headers: {
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json",
          "api-key": API_TMS_KEY
        },
        data
      };
      axios(config)
        .then((response) => {
          if (response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getViewPriceTransporter = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_TMS}/transport-fee`,
        headers: {
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json",
          "api-key": API_TMS_KEY
        },
        data
      };
      axios(config)
        .then((response) => {
          if (response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getShipperStation = (params) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_IN_HOUSE}/shipper`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Basic YmlwYmlwOmJpcGJpcA==`,
          "api-key": API_IN_HOUSE_KEY,
          "x-user-id": this.userId()
        },
        params
      };
      axios(config)
        .then((response) => {
          if (response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateCodRequest = (params) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "put",
        url: `${API_TMS}/update-cod-request-delivery-order/${params.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "api-key": API_TMS_KEY,
          "x-user-id": this.userId()
        },
        data: params.data
      };

      axios(config)
        .then((response) => {
          if (response.data.code === "success") {
            resolve({id: params.id, cashOnDelivery: params.data.cashOnDelivery});
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const waybillService = new WaybillService();

export default waybillService;
